{
  "title": "Willkommen",
  "loading": "Lade Daten...",
  "folderView": {
    "title": "Posteingang"
  },
  "folderActions": {
    "applyAll": "Auf alle Ordner vererben",
    "applySelected": "Auf ausgewählte Ordner vererben"
  },
  "misc": {
    "logout": "Abmelden",
    "login": "Anmelden",
    "close": "Schließen"
  },
  "license": {
    "dialog": {
      "title": "Lizenz Information",
      "client": "Klient",
      "domains": "Domains",
      "type": " Lizenz Typ",
      "expiry": "Gültig bis",
      "productGuid": "Produkt ID"
    },
    "invalid": "Keine gültige Lizenz. Wende dich bitte an deinen Systemadministrator."
  },
  "permissions": {
    "isLoading": "Ordner wird geladen...",
    "displayErrorDetails": "Fehlerdetails anzeigen",
    "errors": {
      "couldNotLoadError": "Der Ordner konnte nicht geladen werden",
      "missingExchangeFolderId": "Dieser Link ist unvollständig. Bitte wähle den Ordner erneut in der Ordnerliste aus."
    },
    "user": "Name",
    "permissionLevel": "Berechtigungsstufe",
    "checkLabel": "Ja",
    "uncheckLabel": "Nein",
    "sortAscLabel": "Aufsteigend sortieren",
    "sortDescLabel": "Absteigend sortieren",
    "unsortedLabel": "Nicht sortieren",
    "createPermissions": "Erstellen",
    "createPermissionsNone": "Keine",
    "createPermissionsItems": "Elemente",
    "createPermissionsSubfolders": "Unterordner",
    "createPermissionsItemsSubfolders": "Elemente + Unterordner",
    "readPermissions": "Lesen",
    "readPermissionsNone": "Keine",
    "readPermissionsFull": "Alle Details",
    "editPermissions": "Bearbeiten",
    "editPermissionsNone": "Keine",
    "editPermissionsOwn": "Eigene",
    "editPermissionsAll": "Alle",
    "deletePermissions": "Löschen",
    "folderPermissions": "Ordnerberechtigungen",
    "folderPermissionsNone": "Keine",
    "isFolderOwner": "Besitzer",
    "isFolderVisible": "Sichtbar",
    "isFolderContact": "Kontakt",
    "modifyAction": {
      "editTitle": "Bearbeiten",
      "addTitle": "Berechtigungen vergeben",
      "closeButton": "Abbrechen",
      "submitButton": "Anwenden",
      "applyRecursive": "Auf alle Unterordner anwenden",
      "personGroup": {
        "label": "Person",
        "noItems": "Keine Personen gefunden",
        "alreadySelected": "- Bereits ausgewählt"
      },
      "levelGroup": {
        "label": "Berechtigungsstufe",
        "options": {
          "owner": "Besitzer",
          "publishingEditor": "Editor mit Veröffentlichungsberechtigung",
          "editor": "Editor",
          "publishingAuthor": "Autor mit Veröffentlichungsberechtigung",
          "author": "Autor",
          "noneditingAuthor": "Autor ohne Bearbeitungsberechtigung",
          "reviewer": "Prüfer",
          "contributor": "Mitwirkender",
          "none": "Keine",
          "custom": "Benutzerdefiniert"
        },
        "warnings": {
          "owner": "Inhaber des ausgewählten Berechtigungslevels können andere Nutzer berechtigen und Ihnen ggf. die Berechtigungen entziehen."
        }
      },
      "readGroup": {
        "label": "Lesen",
        "options": {
          "none": "Keine",
          "full": "Alle Details"
        }
      },
      "deleteGroup": {
        "label": "Löschen",
        "options": {
          "none": "Keine",
          "own": "Eigene",
          "all": "Alle"
        }
      },
      "editGroup": {
        "label": "Bearbeiten",
        "options": {
          "none": "Keine",
          "own": "Eigene",
          "all": "Alle"
        }
      },
      "createGroup": {
        "label": "Erstellen",
        "options": {
          "createItems": "Elemente",
          "createSubfolders": "Unterordner"
        }
      },
      "otherGroup": {
        "label": "Sonstige",
        "options": {
          "folderOwner": "Besitzer des Ordners",
          "folderContact": "Ordnerkontakt",
          "folderVisible": "Ordner sichtbar"
        }
      }
    },
    "actionsColumnTitle": "Aktionen",
    "deleteAction": {
      "buttonLabel": "Löschen",
      "cancelLabel": "Abbrechen",
      "confirmTitle": "Möchten Sie die Berechtigung wirklich löschen?"
    },
    "pagination": {
      "nextLabel": "Nächste",
      "previousLabel": "Vorherige",
      "currentLabel": "Seite "
    }
  },
  "toast": {
    "success": "Erfolg",
    "error": "Fehler",
    "warning": "Warnung",
    "info": "Info",
    "copy": "In die Zwischenablage kopieren",
    "dismiss": "Schließen",
    "unknownError": "Unbekannter Fehler",
    "traceId": "Trace-ID",
    "timestamp": "Zeitstempel"
  },
  "placeholder": {
    "iconText": "Wähle einen Ordner aus",
    "description": "Wähle einen Ordner in der Auflistung aus, um die Berechtigungen einzusehen oder anzupassen."
  },
  "peoplePicker": {
    "errors": {
      "anErrorOccurred": "Ein Fehler ist aufgetreten"
    }
  },
  "rootErrorComponent": {
    "unknownError": {
      "title": "Unbekannter Fehler",
      "description": "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut."
    },
    "backendOfflineError": {
      "title": "Backend nicht verfügbar",
      "description": "Wir können derzeit keine Verbindung zum Server herstellen."
    },
    "retryButtonLabel": "Erneut versuchen"
  }
}